export default __webpack_public_path__ + "static/media/EmailMeasure.b0d01979.svg";